angular.module('trakeyeApp').directive('routeImage', ['$localStorage', 'imageRoutePoint', 'routeDetail', 'RouteImageMeta', 'FileUploadService', function ($localStorage, imageRoutePoint, routeDetail, RouteImageMeta, FileUploadService) {
    return {
        restrict: 'E',
        scope: {
            obj: '='
        },
        templateUrl: 'app/components/View/routeImage.html',
        link: function (scope) {

            var markerImage, iconImg
            var routeMarkers = []
            var iconSize = 20
            var iconMarker = "content/images/sm_marker_transparent.png"
            var iconImage = "content/images/routePointImage.png"
            var openedInfoWindow = null;
            var minRouteMetaUtcTime = 0;
            var metaCoordinates = [];
            var editAttributesValues = []
            google.maps.event.addListener(
                scope.obj.map,
                "zoom_changed",
                function () {
                    scope.obj.zoomLevel = scope.obj.map.getZoom();
                    // scope.$apply();
                }
            );
            scope.obj.toggleMarkers = function () {
                routeMarkers.forEach(function (marker) {
                    if (marker.icon.url !== iconImage) {
                        marker.setVisible(scope.obj.hidemarker);
                    }
                });
            };
            scope.obj.toggleRouteMarkers = function () {
                routeMarkers.forEach(function (marker) {
                    if (marker.icon.url !== iconMarker) {
                        marker.setVisible(scope.obj.hideRoutemarker);
                    }
                });
            };
            google.maps.event.addListener(
                scope.obj.map,
                "idle",
                function () {
                    scope.obj.zoomLevel = scope.obj.map.getZoom();
                    scope.$apply();
                }
            );
            var dragging = false;
            scope.obj.draggedOnce = false
            function loadMediaMarkers() {
                dragging = true
                scope.obj.draggedOnce = true;
                scope.obj.hidemarker = true;
                scope.obj.hideRoutemarker = true;
                var center = scope.obj.map.getCenter();
                imageRoutePoint.postCenterLatLng(scope.obj.routeId, { lat: center.lat(), lng: center.lng() }, function (data) {
                    if (data.length) {
                        for (var i = 0; i < routeMarkers.length; i++) {
                            routeMarkers[i].setMap(null);
                        }
                        routeMarkers = [];
                        callRouteImage(data, scope.obj.map)
                    }
                })

            };
            loadMediaMarkers()
            scope.obj.refreshMarkersFn = function () {
                loadMediaMarkers();
            };
            var customControlDiv = document.createElement('div');
            var customControlText = document.createElement('div');
            // var geocoder = new google.maps.Geocoder();

            scope.initializeMap = function () {
                if (!document.getElementById("map")) {
                    console.error("Map element not found!");
                    return;
                }
                scope.map = new google.maps.Map(document.getElementById("map"), {
                    center: { lat: 13.027893369650114, lng: 77.59144741784749 },
                    zoom: 18,
                    tilt: 45, // Enable 3D mode for rotation
                    heading: 0,
                    // mapId: "90f87356969d889c", // Vector map ID required for tilt and rotation
                    mapTypeControl: false,
                    disableDefaultUI: true,
                    cameraControl: true,
                    fullscreenControl: true
                });

                scope.polyline = new google.maps.Polyline({
                    path: scope.obj.plannedPath,
                    geodesic: true,
                    strokeColor: '#0000FF', // Set polyline color
                    strokeOpacity: 0.4,
                    strokeWeight: 32,
                    map: scope.map
                });

                customControlText.style.backgroundColor = 'rgba(211, 211, 211, 0.7)';
                customControlText.style.color = '#1a237e';
                customControlText.style.fontSize = '12px';
                customControlText.style.fontWeight = 'bold';
                customControlText.style.padding = '12px';
                customControlText.style.margin = '10px';
                customControlText.style.borderRadius = '5px';
                customControlText.style.boxShadow = '0px 2px 5px rgba(0, 0, 0, 0.3)';
                customControlDiv.appendChild(customControlText);
                scope.map.controls[google.maps.ControlPosition.TOP_LEFT].push(customControlDiv);

                scope.polyline = new google.maps.Polyline({
                    path: [],
                    geodesic: true,
                    strokeColor: '#0000FF',
                    strokeOpacity: 0.8,
                    strokeWeight: 16,
                    map: scope.map
                });

                RouteImageMeta.getData(scope.routePointId, function (response) {
                    scope.metaCoordinates = Array.isArray(response) ? response : [];
                    if (!response || response.length === 0) {
                        console.warn("No coordinates received.");
                        return;
                    }
                    minRouteMetaUtcTime = scope.metaCoordinates.reduce(function (min, current) {
                        return current.coordinateDate < min ? current.coordinateDate : min;
                    }, scope.metaCoordinates[0].coordinateDate);

                    scope.metaCoordinates.sort(function (a, b) { return a.sortOrder - b.sortOrder; });
                    // Extract the coordinates and their corresponding coordinateDate
                    scope.coordinates = scope.metaCoordinates.map(function (coord) {
                        return { lat: coord.latitude, lng: coord.longitude, coordinateDate: coord.coordinateDate, gpsAccuracy: coord.gpsAccuracy, timeInSec: (coord.coordinateDate - minRouteMetaUtcTime) / 1000 };
                    });
                    scope.usermarker = new google.maps.Marker({
                        position: scope.coordinates[0],
                        map: scope.map,
                        icon: {
                            url: 'content/images/geoLocationAnim.gif',
                            scaledSize: new google.maps.Size(24, 24),
                            anchor: new google.maps.Point(12, 12)
                        }
                    });

                    // Call animatedMove to start moving the marker with the coordinates from the response
                    animatedMove(scope.usermarker, scope.coordinates, 0);
                });
            };
            var animationTimeout;
            var isPaused = false;
            var currentStep = 0;
            var currentIndex = 0;

            function animatedMove(usermarker, coords, index) {
                currentIndex = index; // Save the current coordinate index

                if (index >= coords.length) return;

                var moveto = new google.maps.LatLng(coords[index].lat, coords[index].lng);

                scope.moveMarker(usermarker, coords, index, moveto); // Start animation
            }

            scope.moveMarker = function (usermarker, coords, index, moveto) {
                if (isPaused) return; // Exit if paused
                usermarker.setPosition(moveto);
                scope.map.setCenter(moveto);
                scope.polyline.getPath().push(moveto);
                showLatLngOnMapForVideo(moveto.lat(), moveto.lng(), coords[index].gpsAccuracy);
                if (index < coords.length - 1) {
                    var nextPoint = coords[index + 1];
                    var bearing = getBearing(moveto.lat(), moveto.lng(), nextPoint.lat, nextPoint.lng);
                    scope.map.setHeading(bearing);
                }
                animationTimeout = setTimeout(function () {
                    animatedMove(usermarker, coords, index + 1);
                }, 900);
            }
            function pauseMarkerAnimation() {
                isPaused = true;
                clearTimeout(animationTimeout); // Stop the ongoing movement
            }
            function resumeMarkerAnimation() {
                if (!isPaused) return;
                isPaused = false;
                if (!scope.usermarker || !scope.coordinates) {
                    console.error("usermarker or coordinates are not defined");
                    return;
                }
                animatedMove(scope.usermarker, scope.coordinates, currentIndex);
            }

            function showLatLngOnMapForVideo(lat, lng, gpsAccuracy) {
                var accuracy = gpsAccuracy;
                if (gpsAccuracy == null) {
                    accuracy = "";
                } else {
                    accuracy.toFixed(2);
                }
                // var latLng = new google.maps.LatLng(lat, lng);
                customControlText.innerHTML = 'Location: ' + lat.toFixed(8) + ', ' + lng.toFixed(8);
                // geocoder.geocode({ 'location': latLng }, function (results, status) {
                //     if (status === google.maps.GeocoderStatus.OK) {
                //         if (results[0]) {
                //             customControlText.innerHTML = 'Lat: ' + lat.toFixed(6) + '<br>Lng: ' + lng.toFixed(6) + '<br>' + results[0].formatted_address;
                //         } else {
                //             customControlText.innerHTML = 'Lat: ' + lat.toFixed(6) + '<br>Lng: ' + lng.toFixed(6) + '<br>No address found.';
                //         }
                //     } else {
                //         customControlText.innerHTML = 'Lat: ' + lat.toFixed(6) + '<br>Lng: ' + lng.toFixed(6) + '<br>Geocode failed: ' + status;
                //     }
                // });
            }

            function getBearing(lat1, lng1, lat2, lng2) {
                var dLon = (lng2 - lng1) * (Math.PI / 180);
                lat1 = lat1 * (Math.PI / 180);
                lat2 = lat2 * (Math.PI / 180);

                var y = Math.sin(dLon) * Math.cos(lat2);
                var x = Math.cos(lat1) * Math.sin(lat2) -
                    Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);
                var brng = Math.atan2(y, x) * (180 / Math.PI);
                return (brng + 360) % 360; // Normalize to 0-360 degrees
            }

            scope.loadAssets = function (routeId, lastId) {
                routeDetail.getAssetsById(routeId, lastId, function (response) {
                    if (response.assets.length > 0) {
                        response.assets.forEach(function (asset) {
                            var coordinates = asset.assetCoordinates.map(function (coord) {
                                return { lat: coord.latitude, lng: coord.longitude };
                            });

                            if (asset.assetTypeLayout === 'FIXED' && asset.phase === 'SURVEY') {
                                scope.map.setCenter(coordinates[0]);
                                var marker = new google.maps.Marker({
                                    position: coordinates[0],
                                    map: scope.map,
                                    title: asset.name,
                                    icon: {
                                        url: asset.assetTypeImagePath,
                                        scaledSize: new google.maps.Size(32, 32)
                                    }
                                });
                                // function updateMarkerLabel() {
                                //     var currentZoom = scope.map.getZoom();
                                //     if (currentZoom > 15) {
                                //         marker.setLabel({
                                //             text: '\n\n\n' + asset.name,
                                //             color: '#000',  // Customize as needed
                                //             fontSize: '12px',
                                //             fontWeight: "bold"
                                //         });
                                //     } else {
                                //         marker.setLabel(null);  // Remove the label if zoom <= 15
                                //     }
                                // }

                                // // Initialize label based on current zoom
                                // updateMarkerLabel();

                                // // Listen for zoom changes and update the label
                                // google.maps.event.addListener(scope.map, 'zoom_changed', function () {
                                //     updateMarkerLabel();
                                // });
                            }
                            else if (asset.assetTypeLayout === 'SPREAD' && asset.phase === 'SURVEY') {
                                var drawPolyline = new google.maps.Polyline({
                                    path: coordinates,
                                    geodesic: true,
                                    strokeColor: '#0000FF',
                                    strokeOpacity: 1.0,
                                    strokeWeight: 3
                                });
                                drawPolyline.setMap(scope.map);
                                // console.log("Polyline added:", drawPolyline);
                            }
                        });
                    }
                    // Handle pagination (if response has more than 50 assets)
                    if (response.assets.length >= 200) {
                        scope.loadAssets(routeId, response.assets[response.assets.length - 1].id);
                    }
                });
            };
            // Initialize map when modal is opened
            $("#mediaModal").on("shown.bs.modal", function () {
                setTimeout(function () {
                    scope.initializeMap();
                }, 1000);
                setTimeout(function () {
                    scope.loadAssets(scope.obj.routeId, null);
                }, 1000);
            });
            scope.currentIndex = 0;
            function callRouteImage(arr, map) {
                markerIds = [];
                var hoverInfoWindow = new google.maps.InfoWindow({ disableAutoPan: true });
                var openedInfoWindow = null;

                arr.forEach(function (each) {
                    if (scope.modalClosing) return;
                    var iconImg = (each.imageAttached) ? iconImage : iconMarker;
                    var markerImage = new google.maps.Marker({
                        position: { lat: each.latitude, lng: each.longitude },
                        map: map,
                        title: each.id.toString(),
                        icon: {
                            scaledSize: new google.maps.Size(iconSize, iconSize),
                            url: iconImg,
                            anchor: new google.maps.Point(iconSize / 2, iconSize / 2),
                            labelOrigin: new google.maps.Point(25, 22),
                        }
                    });
                    if (each.imageAttached) {
                        markerImage.setZIndex(2000);
                    } else {
                        markerImage.setIcon({
                            scaledSize: new google.maps.Size(23, 23),
                            url: iconImg,
                            anchor: new google.maps.Point(22 / 1.2, 22 / 1.2),
                            labelOrigin: new google.maps.Point(25, 22)
                        });
                    }
                    google.maps.event.addListener(markerImage, "click", function () {
                        if (each && each.id && each.imageAttached) {
                            scope.routeImageMarkerId = each.id;
                            scope.imgName = (each.name == null) ? "Marker" : each.name;
                            scope.imgLatitude = each.latitude;
                            scope.imgLongitude = each.longitude;

                            imageRoutePoint.getImagesList(each.id, function (mediaList) {
                                mediaList.sort(function (a, b) {
                                    return a.createdDate - b.createdDate;
                                });

                                mediaList.forEach(function (item) {
                                    item.rID = each.id;
                                });

                                scope.nameImages = mediaList;
                                scope.mediaImagesIds = mediaList;
                                scope.currentIndex = 0;
                                scope.loadMedia(scope.mediaImagesIds[scope.currentIndex]);
                            });

                        } else {
                            if (openedInfoWindow != null) {
                                openedInfoWindow.close();
                            }

                            var contentString = document.createElement("div");
                            contentString.innerHTML =
                                '<div class="infoWindowhead">' +
                                "<br><br>" +
                                "<b>Name : " + each.type + "_" + each.id + "</b><br>" +
                                '<b>Latitude : ' + each.latitude + '</b><br>' +
                                '<b>Longitude : ' + each.longitude +
                                ' <button onclick="copyToClipboard(\'' + each.latitude + ',' + each.longitude + '\', this)" style="font-size:10px; padding:2px 5px; margin-left:5px; cursor:pointer;">Copy</button></b><br>' +
                                "<b>Type : " + each.type + "</b><br>" +
                                "<br></div>";

                            openedInfoWindow = new google.maps.InfoWindow({
                                content: contentString,
                                position: { lat: each.latitude, lng: each.longitude }
                            });

                            openedInfoWindow.open(scope.obj.map);

                            var btnShowAsset = document.createElement("input");
                            btnShowAsset.type = "button";
                            btnShowAsset.value = "Show attributes";
                            btnShowAsset.className = "button";

                            google.maps.event.addDomListener(btnShowAsset, "click", function () {
                                imageRoutePoint.getRouteMarkerDetails(each.id, function (response) {
                                    showAssetAttributesModal(response);
                                });
                            });

                            contentString.appendChild(btnShowAsset);

                            var btnEditAttrbuts = document.createElement("input");
                            btnEditAttrbuts.type = "button";
                            btnEditAttrbuts.value = "Edit attributes";
                            btnEditAttrbuts.className = "button";
                            google.maps.event.addDomListener(btnEditAttrbuts, "click", function () {
                                imageRoutePoint.getRouteMarkerDetails(each.id, function (response) {
                                    editAttributesValues = response;
                                    showAssetAttributesEditModal(editAttributesValues);
                                });
                            });
                            contentString.appendChild(btnEditAttrbuts);
                        }
                    });

                    // (function (markerCopy, eachCopy) {
                    //     google.maps.event.addListener(markerCopy, "mouseover", function () {
                    //         var contentDiv = document.createElement("div");
                    //         contentDiv.innerHTML =
                    //             '<div style="min-width:200px; padding:6px;" id="hoverContent_' + eachCopy.id + '">' +
                    //             '<strong>Upload file for Route ID: ' + eachCopy.id + '</strong><br/><br/>' +
                    //             '<input type="file" id="fileInput_' + eachCopy.id + '" />' +
                    //             '<div id="uploadStatus_' + eachCopy.id + '" style="margin-top:6px;font-size:12px;"></div>' +
                    //             '</div>';

                    //         hoverInfoWindow.setContent(contentDiv);
                    //         hoverInfoWindow.open(map, markerCopy);
                    //         setTimeout(function () {
                    //             hoverInfoWindow.close();
                    //         }, 2000);

                    //         google.maps.event.addListenerOnce(hoverInfoWindow, "domready", function () {
                    //             var fileInput = document.getElementById("fileInput_" + eachCopy.id);
                    //             var statusDiv = document.getElementById("uploadStatus_" + eachCopy.id);
                    //             if (fileInput) {
                    //                 fileInput.addEventListener("change", function (evt) {
                    //                     var file = evt.target.files && evt.target.files[0];
                    //                     if (!file) return;

                    //                     var fileName = file.name;
                    //                     var fileType = (file.name.split('.').pop() || '').toUpperCase();

                    //                     if (fileName.toUpperCase().endsWith("." + fileType)) {
                    //                         fileName = fileName.substring(0, fileName.lastIndexOf('.'));
                    //                     }
                    //                     var finalFileName = fileName + "." + fileType;

                    //                     try {
                    //                         var injector = angular.element(document.body).injector();
                    //                         var FileUploadService = injector.get("FileUploadService");

                    //                         if (statusDiv) statusDiv.innerText = "Uploading...";

                    //                         FileUploadService.uploadFile(file, eachCopy.id, fileType, finalFileName, function (success) {
                    //                             if (statusDiv) statusDiv.innerText = success ? "Upload successful" : "Upload failed";

                    //                             if (success) {
                    //                                 eachCopy.imageAttached = true;
                    //                                 markerCopy.setIcon({
                    //                                     scaledSize: new google.maps.Size(iconSize, iconSize),
                    //                                     url: iconImage,
                    //                                     anchor: new google.maps.Point(iconSize / 2, iconSize / 2),
                    //                                     labelOrigin: new google.maps.Point(25, 22)
                    //                                 });
                    //                                 markerCopy.setZIndex(2000);
                    //                                 hoverInfoWindow.close();
                    //                                 alert("Media uploaded successfully");
                    //                             }
                    //                         });
                    //                     } catch (err) {
                    //                         console.error("FileUploadService not found", err);
                    //                         if (statusDiv) statusDiv.innerText = "Upload error";
                    //                     }
                    //                 });
                    //             }
                    //         });
                    //     });

                    //     google.maps.event.addListener(map, "click", function () {
                    //         hoverInfoWindow.close();
                    //     });
                    // })(markerImage, each);

                    routeMarkers.push(markerImage);
                });
            }

            window.copyToClipboard = function (text) {
                if (navigator.clipboard) {
                    navigator.clipboard.writeText(text).then(function () {
                    }).catch(function (err) {
                        console.error("Clipboard copy failed: ", err);
                    });
                } else {
                    var tempInput = document.createElement("input");
                    tempInput.value = text;
                    document.body.appendChild(tempInput);
                    tempInput.select();
                    document.execCommand("copy");
                    document.body.removeChild(tempInput);
                }
            };
            scope.closeModal = function (id) {
                scope.mediaImagesIds = []
                var container = document.getElementById("carouselMediaContainer");
                if (container) {
                    var video = container.querySelector("video");
                    if (video) {
                        video.pause();
                        video.src = "";
                        video.load();
                    }
                    container.innerHTML = "";
                }
                var thumbContainer = document.getElementsByClassName("thumbnails_container");
                if (thumbContainer) {
                    thumbContainer.innerHTML = "";
                }
                data = null
                $("#" + id).removeClass("in");
                $(".modal-backdrop").remove();
                $("#" + id).hide();
            }

            scope.currentIndex = 0;
            scope.nameImages = [];
            scope.routeName = scope.obj.routeName
            scope.showMediaCarousel = function (markerId, markerInfo) {
                var spinner = document.getElementById("loading-bar-spinner");
                if (spinner) spinner.style.display = "block";

                scope.imgName = markerInfo.name || "Marker";
                scope.imgLatitude = markerInfo.latitude;
                scope.imgLongitude = markerInfo.longitude;

                imageRoutePoint.getImagesList(markerId, function (mediaList) {
                    for (var i = 0; i < mediaList.length; i++) {
                        mediaList[i].rID = markerId;
                    }

                    scope.nameImages = mediaList;
                    scope.currentIndex = 0;

                    if (spinner) spinner.style.display = "none";

                    scope.loadMedia(scope.nameImages[scope.currentIndex]);
                    $("#mediaCarouselModal").modal("show");
                });
            };

            scope.loadMedia = function (media) {
                var container = document.getElementById("carouselMediaContainer");
                var spinner = document.getElementById("loading-bar-spinner");

                if (!container) {
                    console.warn("carouselMediaContainer not ready. Retrying...");
                    setTimeout(function () {
                        scope.loadMedia(media);
                    }, 100);
                    return;
                }

                if (spinner) spinner.style.display = "block";
                container.innerHTML = "";

                var xhr = new XMLHttpRequest();
                xhr.open("GET", 'api/routepoint-images/' + media.rID + '/' + media.imageId, true);
                xhr.setRequestHeader("Authorization", "Bearer " + $localStorage.authenticationToken);
                xhr.responseType = "blob";

                xhr.onload = function () {
                    if (xhr.status === 200) {
                        var mediaUrl = URL.createObjectURL(xhr.response);

                        if (media.imageType === "MP4") {
                            // Video display
                            var video = document.createElement("video");
                            video.controls = true;
                            video.autoplay = true;
                            video.style.maxWidth = "100%";
                            video.style.maxHeight = "70vh";
                            video.style.width = "auto";
                            video.style.height = "auto";
                            video.style.objectFit = "contain";

                            var source = document.createElement("source");
                            source.src = mediaUrl;
                            source.type = "video/mp4";

                            video.appendChild(source);
                            container.appendChild(video);

                        } else {
                            // Image display with zoom and drag
                            var img = document.createElement("img");
                            img.src = mediaUrl;
                            img.style.maxWidth = "100%";
                            img.style.maxHeight = "70vh";
                            img.style.cursor = "grab";
                            img.setAttribute("draggable", "false");
                            img.id = "carouselImage";
                            container.appendChild(img);

                            // Zoom and pan logic
                            var zoom = 1;
                            var minZoom = 1;
                            var maxZoom = 5;
                            var imgOffsetX = 0;
                            var imgOffsetY = 0;

                            function applyTransform() {
                                img.style.transform = 'translate(' + imgOffsetX + 'px, ' + imgOffsetY + 'px) scale(' + zoom + ')';
                                img.style.transition = "transform 0.1s ease-out";
                            }
                            applyTransform();

                            container.addEventListener("wheel", function (e) {
                                e.preventDefault();
                                var delta = Math.sign(e.deltaY);
                                var zoomAmount = 0.1;
                                var newZoom = zoom;

                                if (delta < 0) {
                                    newZoom = Math.min(maxZoom, zoom + zoomAmount);
                                } else {
                                    newZoom = Math.max(minZoom, zoom - zoomAmount);
                                }

                                var scaleFactor = newZoom / zoom;
                                var rect = img.getBoundingClientRect();
                                var mouseX = e.clientX - rect.left;
                                var mouseY = e.clientY - rect.top;

                                if (newZoom === minZoom) {
                                    imgOffsetX = 0;
                                    imgOffsetY = 0;
                                } else {
                                    imgOffsetX -= mouseX * scaleFactor - mouseX;
                                    imgOffsetY -= mouseY * scaleFactor - mouseY;
                                }

                                zoom = newZoom;
                                applyTransform();
                            });

                            var isDragging = false;
                            var startCursorX, startCursorY;
                            var startImgOffsetX, startImgOffsetY;

                            img.addEventListener("mousedown", function (e) {
                                isDragging = true;
                                img.style.cursor = "grabbing";
                                startCursorX = e.clientX;
                                startCursorY = e.clientY;
                                startImgOffsetX = imgOffsetX;
                                startImgOffsetY = imgOffsetY;
                                img.style.transition = "none";
                            });

                            document.addEventListener("mouseup", function () {
                                isDragging = false;
                                img.style.cursor = "grab";
                            });

                            document.addEventListener("mousemove", function (e) {
                                if (!isDragging) return;
                                e.preventDefault();
                                var dx = e.clientX - startCursorX;
                                var dy = e.clientY - startCursorY;
                                imgOffsetX = startImgOffsetX + dx;
                                imgOffsetY = startImgOffsetY + dy;
                                applyTransform();
                            });
                        }

                        $("#mediaCarouselModal").modal("show");
                    } else {
                        alert("No media found");
                        container.innerHTML = "<p>Error loading media</p>";
                    }

                    if (spinner) spinner.style.display = "none";
                };

                xhr.onerror = function () {
                    alert("Network error");
                    container.innerHTML = "<p>Network error</p>";
                    if (spinner) spinner.style.display = "none";
                };

                xhr.send();
            };


            scope.nextMedia = function () {
                if (scope.mediaImagesIds.length > 0) {
                    scope.currentIndex = (scope.currentIndex + 1) % scope.mediaImagesIds.length;
                    scope.loadMedia(scope.mediaImagesIds[scope.currentIndex]);
                }
            };

            scope.prevMedia = function () {
                if (scope.mediaImagesIds.length > 0) {
                    scope.currentIndex = (scope.currentIndex - 1 + scope.mediaImagesIds.length) % scope.mediaImagesIds.length;
                    scope.loadMedia(scope.mediaImagesIds[scope.currentIndex]);
                }
            };
            scope.jumpToMedia = function (index) {
                if (scope.mediaImagesIds[index]) {
                    scope.currentIndex = index;
                    scope.loadMedia(scope.mediaImagesIds[index]);
                }
            };
            scope.downloadMedia = function () {
                var currentMedia = scope.mediaImagesIds[scope.currentIndex];
                if (!currentMedia) return;
                var xhr = new XMLHttpRequest();
                xhr.open("GET", 'api/routepoint-images/' + currentMedia.rID + '/' + currentMedia.imageId, true);
                xhr.setRequestHeader("Authorization", "Bearer " + $localStorage.authenticationToken);
                xhr.responseType = "blob";

                xhr.onload = function () {
                    if (xhr.status === 200) {
                        var blob = xhr.response;
                        var url = window.URL.createObjectURL(blob);
                        var a = document.createElement("a");
                        a.href = url;


                        var fileName = (scope.obj.routeName + "_" + currentMedia.imageName || "media")

                        a.download = fileName;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        window.URL.revokeObjectURL(url);
                    } else {
                        alert("Failed to download media.");
                    }
                };

                xhr.onerror = function () {
                    alert("Network error while downloading.");
                };

                xhr.send();
            };
            scope.downloadAllMedia = function () {
                var spinner = document.getElementById("loading-bar-spinner");
                if (spinner) {
                    spinner.style.display = "block";
                }
                var xhr = new XMLHttpRequest();
                xhr.open('GET', '/api/routepoint/downloadFiles/' + scope.routeImageMarkerId, true);
                xhr.setRequestHeader('Accept', 'application/zip');
                xhr.setRequestHeader("Authorization", "Bearer " + $localStorage.authenticationToken);
                xhr.responseType = 'blob';

                xhr.onload = function () {
                    if (spinner) {
                        spinner.style.display = "none"
                    }
                    if (xhr.status === 200) {
                        var blob = new Blob([xhr.response], { type: 'application/zip' });
                        var link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = scope.obj.routeName + "_" + scope.imgLatitude + "," + scope.imgLongitude + '.zip';
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else {
                        alert('Download failed. Status: ' + xhr.status);
                    }
                };

                xhr.onerror = function () {
                    alert('Request error.');
                };

                xhr.send();
            }

            scope.toggleMaximize = function () {
                var modalDialog = document.querySelector("#mediaCarouselModal .modal-dialog");
                var maximizeBtn = document.getElementById("maximizeBtn");
                var minimizeBtn = document.getElementById("minimizeBtn");

                modalDialog.classList.toggle("fullscreen-modal");

                maximizeBtn.style.display = modalDialog.classList.contains("fullscreen-modal") ? "none" : "inline-block";
                minimizeBtn.style.display = modalDialog.classList.contains("fullscreen-modal") ? "inline-block" : "none";

                // Force a redraw (optional)
                var container = document.getElementById("carouselMediaContainer");
                var current = container.innerHTML;
                container.innerHTML = "";
                container.innerHTML = current;
            };
            scope.modalClosing = false;
            $('#mediaCarouselModal').on('hide.bs.modal', function () {
                scope.modalClosing = true;
            });
            $('#mediaCarouselModal').on('hidden.bs.modal', function () {
                scope.modalClosing = false;
                var container = document.getElementById("carouselMediaContainer");
                if (container) {
                    var video = container.querySelector("video");
                    if (video) {
                        video.pause();
                        video.src = "";
                    }
                    container.innerHTML = "";
                }
            });



            function showAssetAttributesModal(assetVal) {
                var AttributeValues = []
                $("#modalAssetAttributes").show();
                AttributeValues.push({
                    "Id": assetVal.id,
                    "Depth": assetVal.depth,
                    "Distance": assetVal.distance,
                    "Latitude": assetVal.latitude,
                    "Longitude": assetVal.longitude,
                    "LHS Offset": assetVal.lhsOffset,
                    "Land Mark": assetVal.landMark,
                    "Height": assetVal.height,
                    "RHS Offset": assetVal.rhsOffset,
                    "Route Offset": assetVal.routeOffset,
                    "Road Width": assetVal.roadWidth,
                    "RodoMeter Length": assetVal.rodometerLength,
                    "Route Point Type": assetVal.routePointType,
                    "Road Type": assetVal.roadType,
                    "Placement Level": assetVal.placementLevel,
                    "Phase": assetVal.phase,
                    "Status": assetVal.status,
                    "Surrounding Type": assetVal.surroundingType,
                    "Soil Type": assetVal.soilType,
                    "Terrain Area": assetVal.terrainArea,
                })
                var attributes = AttributeValues[0];
                document.getElementById("assetAttributeTable").innerHTML = "";
                var newTable =
                    "<table align='center' style='border: 1px solid black; width: 80%;'>" +
                    "<tr><th style='border: 1px solid black; text-align: center;'>Attribute</th>" +
                    "<th style='border: 1px solid black; text-align: center;'>Attribute Value</th></tr>";

                for (var key in attributes) {
                    if (attributes.hasOwnProperty(key)) {
                        newTable +=
                            "<tr><td style='border: 1px solid black; text-align: center;'>" +
                            key +
                            "</td><td style='border: 1px solid black; text-align: center;'>" +
                            (attributes[key] !== null ? attributes[key] : "N/A") +
                            "</td></tr>";
                    }
                }

                newTable += "</table>";

                document.getElementById("assetNameAssetAttributes").textContent =
                    assetVal.id + " - " + (assetVal.routePointType || "Unknown");
                document.getElementById("assetAttributeTable").innerHTML = newTable;
            }
            scope.closeAssetAttributesModal = function () {
                $("#modalAssetAttributes").removeClass("in");
                $(".modal-backdrop").remove();
                $("#modalAssetAttributes").hide();
            }
          
            function showAssetAttributesEditModal(assetAttributes) {
                $("#marker_Attr_edit").data("original", assetAttributes);
                $("#lhsOffset").val(assetAttributes.lhsOffset || 0);
                $("#rhsOffset").val(assetAttributes.rhsOffset || 0);
                $("#roadType").val(assetAttributes.roadType || "");
                $("#roadWidth").val(assetAttributes.roadWidth || 0);
                $("#landMark").val(assetAttributes.landMark || "N/A");
                $("#rodometerLength").val(assetAttributes.rodometerLength || 0);
                $("#saveMarkerAttr").data("id", assetAttributes.id);

                $("#marker_Attr_edit").modal("show");
            }

            $(document).on("click", "#saveMarkerAttr", function () {
                var original = $("#marker_Attr_edit").data("original");
                var payload = $.extend({}, original, {
                    lhsOffset: $("#lhsOffset").val(),
                    rhsOffset: $("#rhsOffset").val(),
                    roadType: $("#roadType").val(),
                    roadWidth: $("#roadWidth").val(),
                    landMark: $("#landMark").val(),
                    rodometerLength: $("#rodometerLength").val(),
                    routeId: scope.obj.routeId
                });
                imageRoutePoint.updateRouteMarkerAttributs([payload], function (response) {
                    if (response && !response.error) {
                        alert("Marker Attribute updated successfully!");
                        $("#marker_Attr_edit").modal("hide");
                    } else {
                        alert("Failed to update marker.");
                    }
                });
            });
        }
    };
}]);